import axios from "@/axios.js";
import OpportunityFields from "./opportunity_fields_service";

export default {
  getAllOpportunityFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      OpportunityFields.getAllOpportunityFields(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchFields(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/opportunity_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeOpportunityField(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/fields/opportunity_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingFieldLists(context, field_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/opportunity_fields/get_opportunity_existing_field_lists/${field_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/opportunity_fields/update_opportunity_field", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/opportunity_fields/add_fields", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeFields({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/fields/opportunity_fields/${roleId}`)
        .then(response => {
          commit("REMOVE_STEPS", roleId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
